import React from "react";
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  useMediaQuery,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  assayTableTitle: {
    marginBottom: "10px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "color 0.5s",

    "&:hover": {
      transition: "color 0.5s",
      color: theme.palette.primary.main,
    },
  },
  assayTableTitleTime: {
    fontWeight: "600",
  },
  table: {
    wordBreak: "break-all",
    tableLayout: "fixed",
    width: "100%",
  },
  tableForInnerHTML: {
    maxWidth: "95vw",
    color: '#175555',
  },
  columnLabel: {
    fontSize: "12px",
    color: '#175555',
    fontWeight: 600,
    "@media(max-width: 900px)": {
      fontSize: "9px",
    },
  },
  researchDescription: {
    display: "flex",
    rowGap: "10px",
    padding: "10px 10px",
    backgroundColor: "#F8F9F9",
    margin: "10px 0px",
    width: "100%",
  },
  resultLabel: {
    fontSize: "14px",
    fontWeight: 600,
    background: theme.palette.primary.background
  },
}));

const ResultHTML = ({ assay }) => {
  const classes = useStyles();
  const mdUp = useMediaQuery('@media (maxWidth: 950px)');

  return (
    <>
      <div className={classes.assayTableTitle}>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              padding: "0px 10px",
            }}
          >
            <Typography className={classes.columnLabel}>
              Назва дослідження
            </Typography>
            {+assay.ready === 0 ? <Typography variant="caption" color="error">
                  Результати ще не готові. Очікуйте сповіщення про готовність.
                </Typography>
                : <Typography className={classes.columnLabel}>
                  Результат готовий
                </Typography>}
          </div>
          <div className={classes.researchDescription}>
            <Typography
              style={mdUp ? { flex: "3 1 0" } : { flex: "2 1 0" }}
              className={classes.resultLabel}
              color={"textPrimary"}
            >
              {`${assay.packet.length > 0 ? assay.packet : assay.test}`}
            </Typography>
            <Typography
              style={mdUp ? {} : { flex: "2 1 0", textAlign: "end" }}
              className={classes.resultLabel}
              color={"textPrimary"}
              component={"div"}
            >
              <em className={classes.assayTableTitleTime}>
                {+assay.ready !== 0 && assay.utime.slice(0, 16).split("-").join(".")}
              </em>
            </Typography>
          </div>
        </div>
      </div>
      <Table className={classes.table} size="small" padding="none">
        <TableBody className={classes.tableForInnerHTML}>
          <TableRow>
            <TableCell colSpan="4">
              {/* <div 
                ref={hostRef}
                className={classes.tableForInnerHTML}

               /> */}
              <div
                dangerouslySetInnerHTML={{
                  __html: assay.result
                    ? fixHtml(assay.result)
                    : assay.resulttmlt,
                }}
                className={classes.tableForInnerHTML}
              />
                      {/* <iframe
              sandbox="allow-same-origin"
              style={{
                width: '100%',
                border: 'none',
                minHeight: 'max-content',
              }}
              srcDoc={`
    <html>
      <head></head>
      <body>${assay.result}</body>
    </html>
  `}
            /> */}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

function fixHtml(inputHtml) {
  let html = inputHtml;

  // 1️⃣ Add missing quotes around attributes like style=width:100%;
  html = html.replace(/(\s)([a-z-]+)=([^"'\s>]+)/gi, '$1$2="$3"');

  // 2️⃣ Convert border=1 or cellpadding=0 to proper inline styles
  // html = html.replace(/border\s*=\s*"?(\d+)"?/gi, 'style="border:$1px solid black;"');
  html = html.replace(/cellspacing\s*=\s*"?(\d+)"?/gi, '');
  html = html.replace(/cellpadding\s*=\s*"?(\d+)"?/gi, '');

  // 3️⃣ Remove MS Word specific classes and attributes
  html = html.replace(/\sclass="Mso[^"]*"/gi, '');
  html = html.replace(/\slang=[^ >]*/gi, '');
  html = html.replace(/\swidth=[^ >]*/gi, '');
  html = html.replace(/\svalign=[^ >]*/gi, '');

  // 4️⃣ Normalize multiple spaces / &nbsp;
  html = html.replace(/&nbsp;+/g, ' ');
  html = html.replace(/\s{2,}/g, ' ');

  // 5️⃣ Ensure valid style attribute syntax (e.g. add missing quotes)
  html = html.replace(/style=([^"']\S*)/gi, 'style="$1"');

  return html.trim();
}

export default ResultHTML;
